import React from 'react';
import { toast } from 'react-toastify';
import { ArcButton } from '@src/core/ui';
import {  useCancelMissionMutation } from '@src/features/order/redux';
import { CancelMissionOrderButtonProps } from './types';

const CancelMissionOrderButton: React.FC<CancelMissionOrderButtonProps> = (props) => {
  const { missionId, successCallback } = props;
  const [cancelMission, { isLoading }] = useCancelMissionMutation();

  const onCancelGroupOrder = () => {
    cancelMission(missionId).unwrap().then(() => {
      successCallback?.();
      toast.success('Order has been successfully canceled');
    }).catch(() => {});
  };

  return (
    <ArcButton.ghost 
      fullWidth 
      isLoading={isLoading} 
      onClick={onCancelGroupOrder}> 
      Cancel 
    </ArcButton.ghost>
  );
};   

export default CancelMissionOrderButton;